import React, { useEffect, useState } from "react";
import SideBar from "../Components/SideBar";
import { DeleteBlogCommentApi, GetBlogCommentApi, PutBlogCommentApi } from "../callApi/blogComment";
import { useDispatch } from "react-redux";
import { setLoading } from "../../Redux/action";
import { toast } from "react-hot-toast";

export default function BlogCommentStatus() {
  const storedData = localStorage.getItem("adminData") || "{}";
  const adminData = JSON.parse(storedData);
  const AdminId = adminData.AdminId || null;

  const dispatch = useDispatch();

  const [editComment, setEditComment] = useState([]);

  useEffect(() => {
    callApi();
  }, []);

  const callApi = async () => {
    try {
      dispatch(setLoading(true));
      const res = await GetBlogCommentApi("blogComment");
      setEditComment(res);
      sessionStorage.setItem("blogCommentStatusApi", JSON.stringify(res));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      console.error("Error fetching data:", error);
    }
  };

  const handleUpdate = (_id) => {
    const params = {
      AdminId: AdminId,
      Status: "Published"
    };
    PutBlogCommentApi("blogComment/edit/" + _id, params)
      .then((res) => {
        dispatch(setLoading(false));
        setEditComment((prevComments) =>
          prevComments.map((comment) =>
            comment.BlogCommentID === _id ? { ...comment, Status: "Published" } : comment
          )
        );
        toast.success("Comment published successfully");
      })
      .catch((error) => {
        dispatch(setLoading(false));
        console.error("Error updating comment:", error);
        toast.error("Error publishing comment");
      });
  };

  const handleDelete = (_id) => {
    const params = {
      AdminId: AdminId
    };
    DeleteBlogCommentApi(_id, params)
      .then(() => {
        setEditComment((prevComments) => prevComments.filter((comment) => comment.BlogCommentID !== _id));
        toast.success("Comment discarded successfully");
      })
      .catch((error) => {
        console.error("Error deleting comment:", error);
        toast.error("Error discarding comment");
      });
  };

  return (
    <div className="admin-shop-comments">
      <SideBar />
      <div className="admin-container">
        <h1>Blog Comment Status</h1>
        <br />
        <table className="admin-shop-comments-table">
          <thead>
            <tr className="admin-comment-row">
              <th>Title</th>
              <th>Message</th>
              <th>Status</th>
              <th>Edit</th>
            </tr>
          </thead>
          <tbody>
            {editComment.length > 0 ? (
              editComment.map((item, index) => (
                <tr className="admin-comment-row" key={index}>
                  <td>{item.title}</td>
                  <td>{item.message}</td>
                  <td>{item.Status}</td>
                  <td className="admin-comment-button-field">
                    {item.Status === "Pending to publish" && (
                      <button
                        type="button"
                        className="admin-comment-publish"
                        onClick={() => handleUpdate(item.BlogCommentID)}
                      >
                        Publish
                      </button>
                    )}
                    <button
                      type="button"
                      className="admin-comment-delete"
                      onClick={() => handleDelete(item.BlogCommentID)}
                    >
                      Discard
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="admin-comment-row">
                <td colSpan="4">No records Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
